module.exports = __webpack_public_path__ + "assets/img/klm_cn.441a8b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/klm_cn.png
// module id = oZcI
// module chunks = 1